import { useMediaQueries } from '@capsicum/common-web';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';

import { ITEM_WIDTH } from '../../../ui/auction-card/AuctionCard';

export const useColWidth = () => {
	const { breakpoints, spacings } = useTheme();

	const [isMobile, isTableSmallDesktop, isMediumDesktop, isLargeDesktop] = useMediaQueries(
		breakpoints.queries.below.mobile,
		breakpoints.queries.builder.between(breakpoints.points.mobile, breakpoints.points.tabletSmallDesktop),
		breakpoints.queries.builder.between(breakpoints.points.tabletSmallDesktop, breakpoints.points.mediumDesktop),
		breakpoints.queries.above.mediumDesktop
	);

	const spacingConditions = useMemo(
		() => [
			{ condition: isMobile, spacing: spacings.xxxsmall },
			{ condition: isTableSmallDesktop, spacing: spacings.xxsmall },
			{ condition: isMediumDesktop, spacing: spacings.xsmall },
			{ condition: isLargeDesktop, spacing: spacings.xsmall }
		],
		[isMobile, isTableSmallDesktop, isMediumDesktop, isLargeDesktop, spacings]
	);

	const colWidth = useMemo(() => {
		for (const { condition, spacing } of spacingConditions) {
			if (condition) {
				return ITEM_WIDTH + parseInt(spacing);
			}
		}

		return ITEM_WIDTH + parseInt(spacings.xsmall);
	}, [spacingConditions, spacings]);

	return colWidth;
};
